import { Expose } from "class-transformer";

import { PushSubscriptionRequest } from "./push-subscription-request";

export class PushSubscription extends PushSubscriptionRequest {
    @Expose() subscriptionId = -1;
    @Expose() userIdentity = "";
    @Expose() registerDate = "";
}
